import request from "@/utils/request";

// 职工列表
export function staffList(data) {
  return request({
    url: "/user/page",
    method: "POST",
    data,
  });
}

// 职工详情
export function staffDetail(data) {
  return request({
    url: "/user/detail",
    method: "post",
    params: { ...data },
  });
}

// 职工新增/编辑
export function staffAddOrEdit(data) {
  return request({
    url: "/user/addOrEdit",
    method: "post",
    data,
  });
}

// 职工删除
export function staffDelete(data) {
  return request({
    url: "/user/delete",
    method: "post",
    params: { ...data },
  });
}

// 角色列表的接口 /role/page
export function rolePage(data) {
  return request({
    url: "/role/page",
    method: "post",
    data,
  });
}

// 文件上传接口
export function fileUpload(data) {
  return request({
    url: "/file/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 用户解绑  /user/unbind 
export function userUnbind(data) {
  return request({
    url: "/user/unbind",
    method: "post",
    params: { ...data },
  });
}

// 管理员 重置密码 
export function adminChangePassWord(data) {
  return request({
    url: "/user/admin/resetPwd",
    method: "post",
    data
  });
}
